import {FeedRuleType} from '../locationFeed.enums';
import {FeedMappingRule} from '../locationFeed.types';
import getFeedRuleKey from './getFeedRuleKey';

function getFeedRuleValue(ruleType: FeedRuleType, feedMapping: FeedMappingRule) {
  const key = getFeedRuleKey(ruleType);

  return feedMapping[key];
}

export default getFeedRuleValue;
